<template>
  <b-modal ref="modal" hide-footer :title="title" size="lg">
    <div v-if="vendor && lookups">
      <validation-observer ref="observer" v-slot="{ handleSubmit }">
         <b-form @submit.stop.prevent="handleSubmit(onSubmit)">
      <b-row class="my-1">
        <b-col md="3" class="label">
          <label for="title">Title</label>
        </b-col>
        <b-col md="3">
          <validation-provider
            name="Title"
            :rules="{ required: true }"
            v-slot="validationContext"
          >
            <b-form-select
              id="month"
              v-model="vendor.title"
              :options="titles"
              :state="getValidationState(validationContext)"
            ></b-form-select>
            <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
          </validation-provider>

        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col md="3" class="label">
          <label for="firstName">First Name</label>
        </b-col>
        <b-col md="4">
          <b-form-input :disabled="isEdit" id="firstName" v-model="vendor.firstName"></b-form-input>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col md="3" class="label">
          <label for="lastName">Last Name</label>
        </b-col>
        <b-col md="4">
          <b-form-input :disabled="isEdit" id="lastName" v-model="vendor.lastName"></b-form-input>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col md="3" class="label">
          <label for="fullName">Full/Company Name</label>
        </b-col>
        <b-col md="4">
          <b-form-input :disabled="isEdit" id="fullName" v-model="vendor.fullname"></b-form-input>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col md="3" class="label">
          <label for="knownAs">Known As</label>
        </b-col>
        <b-col md="4">
          <b-form-input id="knownAs" v-model="vendor.knownAs"></b-form-input>
        </b-col>
      </b-row>

      <!-- <b-row class="my-1">
        <b-col md="3" class="label">
          <label for="lastName">Last Name</label>
        </b-col>
        <b-col md="4">
          <b-form-input id="lastName" v-model="vendor.lastName"></b-form-input>
        </b-col>
      </b-row> -->

      <b-row class="my-1">
        <b-col md="3" class="label">
          <label for="position">Position</label>
        </b-col>
        <b-col md="4">
          <b-form-input id="position" v-model="vendor.position"></b-form-input>
        </b-col>
        <b-col md="4">
          <b-form-select
            id="companyVendorRoleId"
            v-model="vendor.companyVendorRoleId"
            :options="lookups.companyVendorRoles"
            value-field="id"
            text-field="name"
          >
          </b-form-select>
        </b-col>
      </b-row>


      <b-row class="my-1">
        <b-col md="3" class="label">
        </b-col>
        <b-col md="4">
          <b-form-checkbox
            id="isMainContact"
            v-model="vendor.isMainContact">
            Main Contact
          </b-form-checkbox>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col md="3" class="label">
        </b-col>
        <b-col md="4">
          <b-form-checkbox
            id="isAdvisor"
            v-model="vendor.isAdvisor">
            Advisor
          </b-form-checkbox>
        </b-col>
      </b-row>
      <b-row class="my-1" v-if="vendor.id != null || addingShareholder || addingDirector">
        <b-col md="3" class="label">
        </b-col>
        <b-col md="4">
          <b-form-checkbox
            id="isDirector"
            v-model="vendor.isDirector">
            Director
          </b-form-checkbox>
        </b-col>
      </b-row>

      <b-row class="my-1" v-if="vendor.id != null || addingShareholder || addingDirector">
        <b-col md="3" class="label">
        </b-col>
        <b-col md="4">
          <b-form-checkbox
            id="isShareholder"
            v-model="vendor.isShareholder">
            Shareholder
          </b-form-checkbox>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col md="3" class="label">
          <label for="correspondenceAddressLine1">Correspondence Address</label>
        </b-col>
        <b-col md="4">
          <b-form-input id="correspondenceAddressLine1" v-model="vendor.correspondenceAddressLine1"></b-form-input>
        </b-col>
        <b-col md="5">
          <b-button
            variant="primary"
            block
            size="sm" @click="copyAddress">
            Copy from Trading Address
          </b-button>
        </b-col>
      </b-row>
      <b-row class="my-1">
        <b-col md="3" class="label"></b-col>
        <b-col md="4">
          <b-form-input id="correspondenceAddressLine2" v-model="vendor.correspondenceAddressLine2"></b-form-input>
        </b-col>

      </b-row>
      <b-row class="my-1">
        <b-col md="3" class="label"></b-col>
        <b-col md="4">
          <b-form-input id="correspondenceAddressLine3" v-model="vendor.correspondenceAddressLine3"></b-form-input>
        </b-col>
      </b-row>
      <b-row class="my-1">
        <b-col md="3" class="label"></b-col>
        <b-col md="4">
          <b-form-input id="correspondenceAddressLine4" v-model="vendor.correspondenceAddressLine4"></b-form-input>
        </b-col>
      </b-row>
      <b-row class="my-1">
        <b-col md="3" class="label"></b-col>
        <b-col md="4">
          <b-form-input id="correspondenceAddressLine5" v-model="vendor.correspondenceAddressLine5"></b-form-input>
        </b-col>
      </b-row>
      <b-row class="my-1">
        <b-col md="3" class="label"></b-col>
        <b-col md="4">
          <b-form-input id="correspondenceAddressTown" v-model="vendor.correspondenceAddressTown"></b-form-input>
        </b-col>
      </b-row>
      <b-row class="my-1">
        <b-col md="3" class="label"></b-col>
        <b-col md="4">
          <b-form-input id="correspondenceAddressCounty" v-model="vendor.correspondenceAddressCounty"></b-form-input>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col md="3" class="label">
          <label for="correspondencePostcode">Postcode</label>
        </b-col>
        <b-col md="2">
          <b-form-input id="correspondencePostcode" v-model="vendor.correspondencePostcode"></b-form-input>
        </b-col>
      </b-row>

      <b-row class="my-1" v-if="vendor.isShareholder">
        <b-col md="3" class="label">
          <label for="shareholding">Shareholding</label>
        </b-col>
        <b-col md="2">
          <b-input-group append="%" >
            <b-form-input id="shareholding" type="number" max="100" min="0" step="0.01" v-model="vendor.shareholding"></b-form-input>
          </b-input-group>
        </b-col>
      </b-row>

      <b-row class="my-1" v-if="vendor.isShareholder">
        <b-col md="3" class="label">
          <label for="shareholderSinceMonth">Shareholder Since</label>
        </b-col>
        <b-col md="3">
          <b-form-select
            id="shareholderSinceMonth"
            v-model="vendor.shareholderSinceMonth"
            :options="months"
            value-field="id"
            text-field="name"
          >
          </b-form-select>
        </b-col>
        <b-col md="3">
          <b-form-select
            id="shareholderSinceYonth"
            v-model="vendor.shareholderSinceYear"
            :options="years"
          >
          </b-form-select>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col md="3" class="label">
          <label for="telephoneBusiness" :class="{ red: vendor.telephoneBusinessCtps }">Business</label>
        </b-col>
        <b-col md="3">
          <!-- <validation-provider name="Business" v-slot="validationContext"> -->
            <b-input-group class="mb-2">
              <b-input-group-prepend is-text>
                <font-awesome-icon icon="phone" />
              </b-input-group-prepend>
              <b-form-input id="telephoneBusiness"
                v-model="vendor.telephoneBusiness"
                type="number"
                :class="{ red: vendor.telephoneBusinessCtps }"
              ></b-form-input>
              <!-- <b-form-invalid-feedback id="input-1-live-feedback">{{ validationContext.errors[0] }}</b-form-invalid-feedback> -->
            </b-input-group>
          <!-- </validation-provider> -->
        </b-col>
        <b-col md="2">
          <b-form-radio
            v-model="vendor.companyVendorPreferredContactNumberId"
            value="10">
            Primary
          </b-form-radio>
        </b-col>
        <b-col md="3">
          <b-form-checkbox
            id="doNotUseTelephoneBusiness"
            v-model="vendor.doNotUseTelephoneBusiness">
            Do Not Use
          </b-form-checkbox>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col md="3" class="label">
          <label for="telephoneMobile" :class="{ red: vendor.telephoneMobileCtps }">Mobile</label>
        </b-col>
        <b-col md="3">
          <b-input-group class="mb-2">
            <b-input-group-prepend is-text>
              <font-awesome-icon icon="phone" />
            </b-input-group-prepend>
            <b-form-input id="telephoneMobile" v-model="vendor.telephoneMobile"
            :class="{ red: vendor.telephoneMobileCtps }"
            type="number"></b-form-input>
          </b-input-group>
        </b-col>
        <b-col md="2">
          <b-form-radio
            v-model="vendor.companyVendorPreferredContactNumberId"
            value="20">
            Primary
          </b-form-radio>
        </b-col>
        <b-col md="3">
          <b-form-checkbox
            id="doNotUseTelephoneMobile"
            v-model="vendor.doNotUseTelephoneMobile">
            Do Not Use
          </b-form-checkbox>
        </b-col>
      </b-row>
      <b-row v-if="vendor.mobileConsent">
        <b-col md="3" class="label">
          <label for="telephoneMobileConsent">Consent</label>
        </b-col>
         <b-col md="8" class="ml-3">
          <b-row class="mb-1" v-for="item in vendor.mobileConsent" :key="item.contactConsentType.id">
            <b-form-checkbox :id="'mobileConsentType'  + item.contactConsentType.id" v-model="item.consent" @change="item.updated=true">
              {{ item.contactConsentType.name }} <small><small><i>{{ item.createdBy }}</i></small></small> 
            </b-form-checkbox>
          </b-row>

         </b-col>
      </b-row>
      <b-row class="my-1">
        <b-col md="3" class="label">
          <label for="telephoneAlternative" :class="{ red: vendor.telephoneAlternativeCtps }">Alternative</label>
        </b-col>
        <b-col md="3">
          <b-input-group class="mb-2">
            <b-input-group-prepend is-text>
              <font-awesome-icon icon="phone" />
            </b-input-group-prepend>
            <b-form-input id="telephoneAlternative" v-model="vendor.telephoneAlternative" :class="{ red: vendor.telephoneAlternativeCtps }" type="number"></b-form-input>
          </b-input-group>
        </b-col>
        <b-col md="2">
          <b-form-radio
            v-model="vendor.companyVendorPreferredContactNumberId"
            value="30">
            Primary
          </b-form-radio>
        </b-col>
        <b-col md="3">
          <b-form-checkbox
            id="doNotUseTelephoneAlternative"
            v-model="vendor.doNotUseTelephoneAlternative">
            Do Not Use
          </b-form-checkbox>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col md="3" class="label">
          <label for="companyVendorPreferredContactTimeHour">Preferred Contact Time</label>
        </b-col>
        <b-col md="3">
          <b-form-select
            id="companyVendorPreferredContactTimeHour"
            v-model="preferredContactTime"
            :options="callbackTime"
          >
          </b-form-select>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col md="3" class="label">
          <label for="emailAddress">Email Address</label>
        </b-col>
        <b-col md="6">
          <b-input-group class="mb-2">
            <b-input-group-prepend is-text>
              <font-awesome-icon icon="envelope" />
            </b-input-group-prepend>
            <b-form-input id="emailAddress" v-model="vendor.emailAddress" type="email"></b-form-input>
          </b-input-group>
        </b-col>
        <b-col md="3">
          <b-form-checkbox
            v-model="vendor.doNotUseEmailAddress">
            Do Not Use
          </b-form-checkbox>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col md="3" class="label">
          <label for="emailAddressAlternative">Email Address Alternative</label>
        </b-col>
        <b-col md="6">
          <b-input-group class="mb-2">
            <b-input-group-prepend is-text>
              <font-awesome-icon icon="envelope" />
            </b-input-group-prepend>
            <b-form-input id="emailAddreemailAddressAlternativess" v-model="vendor.emailAddressAlternative" type="email"></b-form-input>
          </b-input-group>
        </b-col>
        <b-col md="3">
          <b-form-checkbox
            v-model="vendor.doNotUseEmailAddressAlternative">
            Do Not Use
          </b-form-checkbox>
        </b-col>
      </b-row>

      <SubHeader title="Financial Details" />

      <b-row class="my-1">
        <b-col md="3" class="label">
          <label for="age">Vendor Age</label>
        </b-col>
        <b-col md="6">
          <b-form-input id="age" v-model="vendor.age"></b-form-input>
        </b-col>
      </b-row>

      <!-- <b-row class="my-1">
        <b-col md="3" class="label">
          <label for="isStayPostSale">Vendor willing to stay post sale</label>
        </b-col>
        <b-col md="6">
          <b-form-select
            id="isStayPostSale"
            v-model="vendor.isStayPostSale"
            :options="yesNo"
          >
          </b-form-select>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col md="3" class="label">
          <label for="companyVendorLevelOfMotivationId">Level of Motivation</label>
        </b-col>
        <b-col md="6">
          <b-form-select
            id="companyVendorLevelOfMotivationId"
            v-model="vendor.companyVendorLevelOfMotivationId"
            :options="levelOfMotivation"
          >
          </b-form-select>
        </b-col>
      </b-row> -->

      <!-- <b-row class="my-1">
        <b-col md="3" class="label">
          <label for="correspondenceInstructions">Correspondence Instructions</label>
        </b-col>
        <b-col md="6">
          <b-form-input id="correspondenceInstructions" v-model="vendor.correspondenceInstructions"></b-form-input>
        </b-col>
      </b-row> -->

      <b-row class="my-1">
        <b-col md="3" class="label">
          <label for="additionalNotes">Additional Notes</label>
        </b-col>
        <b-col md="6">
          <b-form-textarea id="additionalNotes" v-model="vendor.additionalNotes"></b-form-textarea>
        </b-col>
      </b-row>

      <!-- <b-row class="my-1">
        <b-col md="3" class="label">
          <label for="reasonForGoingToMarket">Reason for Going to Market</label>
        </b-col>
        <b-col md="6">
          <b-form-textarea id="reasonForGoingToMarket" v-model="vendor.reasonForGoingToMarket"></b-form-textarea>
        </b-col>
      </b-row> -->

      <b-row class="my-1">
        <b-col md="3">
          <label for="input-none"></label>
        </b-col>
        <b-col md="9">
          <b-button type="submit" variant="success"  class="margin-right">
            <font-awesome-icon icon="save" /> Save
          </b-button>
          <b-button type="reset" variant="danger" @click="cancel">
            <font-awesome-icon icon="times" /> Cancel Changes
          </b-button>
        </b-col>
      </b-row>
      </b-form>
      </validation-observer>
    </div>
  </b-modal>
</template>

<script>
import SubHeader from "@/components/shared/SubHeader.vue";
import CompanyService from "@/services/Company.service";

export default {
  components: { SubHeader },
  props: {
    vendor: Object,
    lookups: Object,
    addingShareholder: Boolean,
    addingDirector: Boolean,
    company: Object
  },
  created() {
    var now = new Date()
    var currentYear = now.getFullYear()

    for(var i = currentYear; i >= currentYear - 100; i--) {
      this.years.push(i)
    }
  },
  watch: {
    vendor: function() {
      if (this.vendor.id > 0) {
        this.title = "Edit Vendor"
        this.isEdit = true

        console.log(this.vendor.mobileConsent);

        if (this.vendor.companyVendorPreferredContactTimeHour && this.vendor.companyVendorPreferredContactTimeMinute) {
          this.preferredContactTime = `${this.vendor.companyVendorPreferredContactTimeHour}:${this.vendor.companyVendorPreferredContactTimeMinute}`
        }

      } else {
        this.title = "Add Vendor"
        this.isEdit = false
      }
    },
  },
  data() {
    return {
      isEdit: false,
      title: "Add Vendor",
      titles: ["Mr", "Miss", "Mrs", "Ms", "Dr"],
      yesNo: [{ value: null, text: ""}, { value: true, text: "Yes"},{ value: false, text: "No"},],
      levelOfMotivation:[
        { value: 0,	text: "Unknown"},
        { value: 10, text: "High"},
        { value: 20, text: "Medium"},
        { value: 30, text: "Low"}],
        months: [
        { id: 1, name: "January"},
        { id: 2, name: "February"},
        { id: 3, name: "March"},
        { id: 4, name: "April"},
        { id: 5, name: "May"},
        { id: 6, name: "June"},
        { id: 7, name: "July"},
        { id: 8, name: "August"},
        { id: 9, name: "September"},
        { id: 10, name: "October"},
        { id: 11, name: "November"},
        { id: 12, name: "December"}],
        years: [],
        callbackTime: [
          { value: null, text: "Select Time", disabled: true },
          { value: "8:0", text: "8:00 AM" },
          { value: "8:15", text: "8:15 AM" },
          { value: "8:30", text: "8:30 AM" },
          { value: "8:45", text: "8:45 AM" },
          { value: "9:0", text: "9:00 AM" },
          { value: "9:15", text: "9:15 AM" },
          { value: "9:30", text: "9:30 AM" },
          { value: "9:45", text: "9:45 AM" },
          { value: "10:0", text: "10:00 AM" },
          { value: "10:15", text: "10:15 AM" },
          { value: "10:30", text: "10:30 AM" },
          { value: "10:45", text: "10:45 AM" },
          { value: "11:0", text: "11:00 AM" },
          { value: "11:15", text: "11:15 AM" },
          { value: "11:30", text: "11:30 AM" },
          { value: "11:45", text: "11:45 AM" },
          { value: "12:0", text: "12:00 PM" },
          { value: "12:15", text: "12:15 PM" },
          { value: "12:30", text: "12:30 PM" },
          { value: "12:45", text: "12:45 PM" },
          { value: "13:0", text: "1:00 PM" },
          { value: "13:15", text: "1:15 PM" },
          { value: "13:30", text: "1:30 PM" },
          { value: "13:45", text: "1:45 PM" },
          { value: "14:0", text: "2:00 PM" },
          { value: "14:15", text: "2:15 PM" },
          { value: "14:30", text: "2:30 PM" },
          { value: "14:45", text: "2:45 PM" },
          { value: "15:0", text: "3:00 PM" },
          { value: "15:15", text: "3:15 PM" },
          { value: "15:30", text: "3:30 PM" },
          { value: "15:45", text: "3:45 PM" },
          { value: "16:0", text: "4:00 PM" },
          { value: "16:15", text: "4:15 PM" },
          { value: "16:30", text: "4:30 PM" },
          { value: "16:45", text: "4:45 PM" },
          { value: "17:0", text: "5:00 PM" },
          { value: "17:15", text: "5:15 PM" },
          { value: "17:30", text: "5:30 PM" },
          { value: "17:45", text: "5:45 PM" },
          { value: "18:0", text: "6:00 PM" },
          { value: "18:15", text: "6:15 PM" },
          { value: "18:30", text: "6:30 PM" },
          { value: "18:45", text: "6:45 PM" },
          { value: "19:0", text: "7:00 PM" },
          { value: "19:15", text: "7:15 PM" },
          { value: "19:30", text: "7:30 PM" },
          { value: "19:45", text: "7:45 PM" },
          { value: "20:0", text: "8:00 PM" },
          { value: "20:15", text: "8:15 PM" },
          { value: "20:30", text: "8:30 PM" },
          { value: "20:45", text: "8:45 PM" },
          { value: "21:0", text: "9:00 PM" },
      ],
      preferredContactTime: null
    }
  },
  methods: {
    showModal() {
      this.$refs["modal"].show();
    },
    hideModal() {
      this.$refs["modal"].hide();
    },
    cancel() {
      this.$parent.$parent.$parent.$parent.loadData()
      this.$refs["modal"].hide();
    },
    onSubmit() {

      if (this.preferredContactTime) {
        var time = this.preferredContactTime.split(":")
        this.vendor.companyVendorPreferredContactTimeHour = time[0]
        this.vendor.companyVendorPreferredContactTimeMinute = time[1]
      }
      console.log(this.vendor.mobileConsent);
      CompanyService.saveCompanyVendor(this.vendor).then(() => {
        this.$parent.$parent.$parent.$parent.loadData()
        this.hideModal()
      })
    },
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    copyAddress() {
      this.vendor.correspondenceAddressLine1 = this.company.addressLine1
      this.vendor.correspondenceAddressLine2 = this.company.addressLine2
      this.vendor.correspondenceAddressLine3 = this.company.addressLine3
      this.vendor.correspondenceAddressLine4 = this.company.addressLine4
      this.vendor.correspondenceAddressLine5 = this.company.addressLine5
      this.vendor.correspondenceAddressTown = this.company.addressTown
      this.vendor.correspondenceAddressCounty = this.company.addressCounty
      this.vendor.correspondencePostcode = this.company.postcode
    }   
  }
}
</script>

<style scoped>
  .label {
    text-align: right;
  }
  .label > label {
    margin-top: 6px;
  }
</style>
